export const customerKeys = {
  // Alapvető cég adatok
  'Szerződés száma': '',
  'Cég megnevezése': '',
  'Cég címe': '',
  'Cég adószáma': '',
  'Cégjegyzékszám': '',
  'Bankszámlaszáma': '',

  // Kapcsolattartók
  'Képviselő neve': '',
  'Kapcsolattartó neve': '',
  'Kapcsolattartó e-mail': '',
  'Kapcsolattartó telefon': '',
  'Kapcsolattartó fax': '',

  'Pénzügyi kapcsolattartó neve': '',
  'Pénzügyi kapcsolattartó e-mail': '',
  'Pénzügyi kapcsolattartó telefon': '',

  // Dátumok és szerződéses adatok
  'Dátum': '',
  'Fizetési határidő': '',
  'Szerződés kezdete': '',
  'Szerződés vége': '',
  'Szerződéses ár': '',
  'Valutanem': ''
};
